import { TransferDirection, TransferType } from '@Types'
import { CancelScheduleTransfer } from '../../api/useCancelScheduledTransfer'

export const payloadTransform = (
  id: string,
  transferType: TransferType,
  direction?: TransferDirection,
  suppliedComment?: string
): CancelScheduleTransfer => {
  if (transferType === 'WIRE' && direction === 'WITHDRAWAL') {
    return { scheduleId: id, transferType: `wires/withdrawals`, comment: suppliedComment }
  }
  if (transferType === 'ACH' && direction === 'WITHDRAWAL') {
    return { scheduleId: id, transferType: `achs/withdrawals`, comment: suppliedComment }
  }
  if (transferType === 'ACH' && direction === 'DEPOSIT') {
    return { scheduleId: id, transferType: `achs/deposits`, comment: suppliedComment }
  }
  if (transferType === 'CASH_JOURNAL') {
    return { scheduleId: id, transferType: `journal`, comment: suppliedComment }
  }
  return { scheduleId: id, transferType: transferType.toLowerCase(), comment: suppliedComment }
}
